import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SystemUpdater, SystemActions, BreadcrumbActions } from '~/actions'
import { SystemFactory } from '~/editors/system'

import style from './style.css';

class SystemInfoScreen extends React.Component {

  componentDidMount() {
    this.props.dispatch( SystemActions.get( this.props.match.params.systemId ) );
  }

  componentWillReceiveProps( next ) {
    const { systems } = next
    const { match, dispatch } = this.props
    const { params } = match
    const systemId = params.systemId
    const system = systems.lookup[systemId]
    if ( system ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${system.projectId}/system` }, 
          { name : system.name } ] ) )
    }
  
  }
  
  onSystemChange = ( event ) => {
    SystemUpdater( this.props.dispatch, event.target )
      .set( event.path, event.value )
      .done();
  }

  render() {
    const { systems } = this.props

    const { params } = this.props.match
    const systemId = params.systemId
    const system = systems.lookup[systemId]
    if ( system == null ) {
      return null
    }

    const details = SystemFactory.createEditor( system, { system, onChange : this.onSystemChange } );
    return <div className={style.pad}>{details}</div>
  }
}

export default connect(
  state => ( {
    systems : state.systems
  } )
)( SystemInfoScreen );
